import { render, staticRenderFns } from "./SubjectBalanceList.vue?vue&type=template&id=0c873c02&scoped=true"
import script from "./SubjectBalanceList.vue?vue&type=script&lang=js"
export * from "./SubjectBalanceList.vue?vue&type=script&lang=js"
import style0 from "./SubjectBalanceList.vue?vue&type=style&index=0&id=0c873c02&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c873c02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c873c02')) {
      api.createRecord('0c873c02', component.options)
    } else {
      api.reload('0c873c02', component.options)
    }
    module.hot.accept("./SubjectBalanceList.vue?vue&type=template&id=0c873c02&scoped=true", function () {
      api.rerender('0c873c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/gledger/SubjectBalanceList.vue"
export default component.exports